export default angular.module('syAlert', ['ngCookies'])
    .service('AlertService', function ($cookies) {
        var cookieNamespace = 'synergy.alert.';
        // Return Alert object from id and expiry for use in alert module
        // @param id {string} The cookie id to use
        // @param expry {date} The date the cookie should expire
        this.generateAlert = function (id, expiry, isActive) {
            return {
                id: id,
                expiry: expiry || null, // null is session length cookie
                isActive: typeof isActive === 'boolean' ?
                    isActive : $cookies.get(cookieNamespace + id) === undefined
            };
        };
        // Save a cookie to track the acknowledgement of this alert
        // @param id {string} The cookie id to use
        // @param expry {date} The date the cookie should expire
        this.saveAlertCookie = function (alert) {
            $cookies.put(cookieNamespace + alert.id, true, {
                expires: alert.expiry
            });
        };
    })
    /**
     * @ngdoc controller
     * @name alert.controller:alertController
     * @description
     * Manages each alert's lifecycle through cookies. If the alert has been
     * acknowledged previously it will hide it unless it has a `alert--active`
     * which will override any cookie or similar functionality
     */
    // @ngInject
    .controller('AlertController', function ($scope, AlertService, AnalyticsService) {
        var controller = this;
        var alert = null;
        // Initialize an alert and store locally to manipulate/watch
        this.registerAlert = function (id, expiry, isActive) {
            return (alert = AlertService.generateAlert(id, expiry, isActive));
        };
        // Toggle the current alert's active state
        // @param override {boolean} The active state required (toggle if null)
        this.toggle = function (override) {
            return (alert.isActive = typeof override === 'boolean' ?
                override : !alert.isActive);
        };
        // Return true when the current alert is active
        this.isActive = function () {
          return alert.isActive;
        };
        // Mark the current alert as seen via until cookieExpiry
        // @param id {string} A unique identifier for this alert
        // @param expry {date} The date this acknowledgement should end
        this.acknowledgeAlert = function () {
            controller.toggle(false);
            AlertService.saveAlertCookie(alert);
            AnalyticsService.trackEvent('Link Interaction',
                                        alert.id === 'cookie' ? 'Cookie Alert Closed' : 'Service Alert Closed',
                                        alert.description || alert.id);
        };
    })
    /**
     * @ngdoc directive
     * @name alert.directive:alert
     * @restrict A
     * @description
     * Tracks the state of visibility for each alert via a controller
     */
    // @ngInject
    .directive('syAlert', function ($timeout) {
        return {
            scope: true,
            controller: 'AlertController',
            restrict: 'A',
            link: function ($scope, $element, attrs, controller) {
                var id = attrs.id;
                var expiry = attrs.id === 'cookie' ?
                        new Date(new Date().setYear(new Date().getFullYear() + 2)) : null;
                var isActive = $element.hasClass('alert--active') || null;
                var alert = controller.registerAlert(id, expiry, isActive);
                // Load the description, if available, of this alert for tracking
                var descriptionElement = angular.element($element[0]
                        .getElementsByClassName('alert-description'));
                if (descriptionElement.length === 1) {
                    alert.description = descriptionElement.text().trim();
                }
                // When the state of the alert changes, update class for visibility
                $scope.$watch(controller.isActive, function (isActive) {
                    $timeout(function () {
                        $element.toggleClass('alert--active', isActive);
                    }, isActive && 300 || 0);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name alert.directive:alertToggle
     * @restrict A
     * @description
     * Acknolwedges and removes a cookie when clicked.
     */
    // @ngInject
    .directive('syAlertToggle', function ($timeout) {
        return {
            restrict: 'A',
            require: '^syAlert',
            link: function ($scope, $element, attrs, controller) {
                $element.on('click touchend', function (e) {
                    e.preventDefault();
                    $timeout(function () {
                        controller.acknowledgeAlert();
                    });
                });
            }
        };
    });
